import script from "./mappedFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./mappedFiles.vue?vue&type=script&setup=true&lang=js"

import "./mappedFiles.vue?vue&type=style&index=0&id=27bd80e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27bd80e6"]])

export default __exports__